export const navLinks = [
  { label: 'HOME', href: '#home' },
  { label: 'COUPLE', href: '#couple' },
  { label: 'STORY', href: '#story' },
  { label: 'EVENTS', href: '#events' },
  { label: 'GALLERY', href: '#gallery' },
];

export const heroData = {
  brideName: 'Niharika',
  groomName: 'Ritik',
  weddingDate: 'April 25, 2026',
  tagline: 'We Are Getting Married',
  heroImages: [
    '/image_1.jpg',
    '/image_2.png',
    '/image_3.jpg',
  ],
};

export const countdownDate = new Date('2026-04-25T00:00:00');

export const coupleData = {
  bride: {
    name: 'Niharika',
    description: 'With Niharika, silence is rare — but so is boredom. 😊\nShe brings laughter, endless conversations, and just the right amount of drama to keep life interesting. 🎭✨\nDependable at heart, a little moody by design, and impossible not to love. 💖',
    attribution: '— From Ritik 🤍',
    image: '/image_4.jpg',
    icon: 'https://sukun.wpocean.site/wp-content/uploads/sites/19/2024/12/bride2.svg',
  },
  groom: {
    name: 'Ritik',
    description: 'He is a man of few words, but countless feelings. 🤍\nHe may not say much, but shows his love through care, concern, and silent efforts that speak louder than words. ✨\nSakht on the outside, softest at heart. 💫\nHe understands more than I explain, and loving him feels like the safest place in the world. 💖',
    attribution: '— From Niharika 🌸',
    image: '/image_4.jpg',
    icon: 'https://sukun.wpocean.site/wp-content/uploads/sites/19/2024/12/groom2.svg',
  },
};

export const storyData = [
  {
    id: 1,
    title: 'First Time We Met ✨',
    date: '15 Jun 2025',
    description: 'It felt like a moment we had quietly been waiting for. 💫\nThere was a gentle nervousness, a shared curiosity — wondering if our hearts would understand each other. 🤍\nBut somewhere between the first few words and soft smiles, everything became easy. 😊\nConversations flowed, time slipped away, and in that quiet beginning… something felt beautifully right. 💖',
    image: '/image_5.png',
  },
  {
    id: 2,
    title: 'Family Meeting 🤍✨',
    date: '26 Jun 2025',
    description: 'What began with two hearts soon brought two families together. 💞\nWarm smiles turned into heartfelt conversations, and laughter filled the room. 😊\nIn that gentle exchange of stories and promises, with love and acceptance all around, ✨\nwhat was once just a bond blossomed into something official — 🌸\nthe beginning of one big, beautiful family. 💖',
    image: '/image_6.png',
  },
  {
    id: 3,
    title: 'First Date 🌸✨',
    date: '15 Aug 2025',
    description: 'Days turned into weeks of little conversations and growing excitement, 💬\nas we quietly looked forward to meeting again. 💫\nEvery plan, every detail carried a hint of something special — 💖\nas if we both knew this was leading to something beautiful. ✨',
    image: '/image_7.png',
  },
  {
    id: 4,
    title: 'Engagement 💫✨',
    date: '30 Oct 2025',
    description: 'In a moment filled with love and quiet happiness, ❤️\nwe exchanged rings — a promise that felt deeper than words. 💞\nSurrounded by our families and their blessings, 👨‍👩‍👧‍👦\ntwo hearts found certainty in each other. 💖\nWhat began as a journey of knowing slowly turned into forever, ♾️\nsealed with love, trust, and a beautiful beginning. 🌸',
    image: '/image_8.jpg',
  },
];

export const eventsData = [
  {
    id: 1,
    title: 'Mehendi🌿✨',
    date: '23 April 2026',
    day: 'Thursday',
    timeNote: '7:00 PM · Evening',
    venue: 'Manthan Banquet, Gwalior',
    mapLink: 'https://maps.app.goo.gl/zdcUQbXKrCFWHtqC9',
    showVenue: false,
    description: `A celebration of colors, laughter, and joyful beginnings. 🎨💛\nAs hands are adorned with intricate patterns, love finds its way into every detail.\nHidden within the designs lie our names, waiting to be found by each other — 💫\na playful tradition wrapped in love and smiles. 😊\nSurrounded by music and vibrant hues, we begin our celebrations with warmth and happiness. 🎶🌸`,
    image: '/mehdi.png',
    isHero: false,
  },
  {
    id: 2,
    title: 'Haldi💛🌼',
    date: '25 April 2026',
    day: 'Saturday',
    timeNote: '10:00 AM · Morning',
    venue: 'Manthan Banquet, Gwalior',
    mapLink: 'https://maps.app.goo.gl/zdcUQbXKrCFWHtqC9',
    showVenue: true,
    description: `A ceremony filled with warmth, laughter, and golden hues.\nAs turmeric is gently applied, we are playfully colored in each other's shades of love. ✨\nEach touch carries blessings of happiness and a new beginning.\nAmid smiles and joyful moments, this ritual wraps us in warmth before the big day. 😊🌞`,
    image: '/haldi.png',
    isHero: false,
  },
  {
    id: 3,
    title: 'Wedding💫✨',
    date: '25 April 2026',
    day: 'Saturday',
    timeNote: '7:00 PM · Evening',
    venue: 'Manthan Banquet, Gwalior',
    mapLink: 'https://maps.app.goo.gl/zdcUQbXKrCFWHtqC9',
    showVenue: true,
    description: `Under the open sky, with stars as our witness ⭐,\nand the presence of God, family, and friends around us 🤍,\nwe take our sacred vows — promising a lifetime of love ❤️.\nIn that beautiful moment, hearts align and souls become one 💞,\nbeginning a forever written in love and blessings ✨💖.`,
    image: '/shadi.png',
    isHero: true,
  },
  {
    id: 4,
    title: 'Reception🥂✨',
    date: '27 April 2026',
    day: 'Monday',
    timeNote: '7:00 PM · Evening',
    venue: 'Krishnam, Moth',
    mapLink: 'https://maps.app.goo.gl/XxQyKC5sRkJrrvAk9',
    showVenue: true,
    description: `An evening of celebration, where love shines a little brighter.\nSurrounded by our families and friends, 🤍\nwe come together to celebrate not just a union,\nbut the beginning of a forever filled with love and togetherness.\nWith laughter, music, and joyful hearts, 🎶😊\nwe celebrate our happily ever after. 💫💖`,
    image: '/reception.png',
    isHero: false,
  },
];

export const ctaImage = '/image_9.jpg';

export const galleryImages = [
  'image_10.jpg',
  'image_11.png',
  'image_12.png',
  'image_14.jpg',
  'image_13.png',
  'image_15.jpg',
];

export const rsvpOptions = {
  attendance: ['Yes, I will be there', "Sorry, I can't come"],
  guests: ['01', '02', '03', '04', '05', '06'],
  meals: ['Chicken Soup', 'Mutton Kabab', 'Chicken BBQ', 'Mix Salad', 'Beef Ribs'],
};

export const blogPosts = [
  {
    id: 1,
    title: 'Perfect Wedding Gown for Your Special Day',
    date: 'January 6, 2025',
    author: 'Admin',
    image: 'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/blog-4.jpg',
  },
  {
    id: 2,
    title: 'A Great Photographer is a Must Have',
    date: 'January 6, 2025',
    author: 'Admin',
    image: 'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/blog-5.jpg',
  },
  {
    id: 3,
    title: 'Top Wedding Bouquet Styles for Bride',
    date: 'January 6, 2025',
    author: 'Admin',
    image: 'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/blog-6.jpg',
  },
];

export const partnerLogos = [
  'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/client1.png',
  'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/client2.png',
  'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/client3.png',
  'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/client4.png',
  'https://sukun.wpocean.site/wp-content/uploads/sites/19/2025/01/client5.png',
];


